import React from 'react'
import {
  MdInsertChart,
  MdLocalActivity,
  MdOutlineBedroomChild,
  MdOutlineEnergySavingsLeaf,
  MdRoute
} from 'react-icons/md'
import { GiHealthIncrease, GiModernCity } from 'react-icons/gi'
import {
  TbKeyframes,
  TbNurse,
  TbProgressCheck,
  TbTimeDuration30
} from 'react-icons/tb'
import { BiTrafficCone } from 'react-icons/bi'
import { GoWorkflow } from 'react-icons/go'
import { BsBuildingGear } from 'react-icons/bs'
import { FaBorderNone, FaParking } from 'react-icons/fa'
import { FaPeopleGroup } from 'react-icons/fa6'
import { HiOutlineLightBulb } from 'react-icons/hi'

export const rating_fields = [
  {
    name: 'judge_weighted_average_score',
    label: `Total`,
    svg: <MdInsertChart />
  },
  {
    name: 'liikenne_ja_pysäköinti',
    label: 'LIIKENNE JA PYSÄKÖINTI',
    svg: <FaParking />
  },
  {
    name: 'palvelut_ja_liiketilat',
    label: 'PALVELUT JA LIIKETILAT',
    svg: <MdLocalActivity />
  },
  {
    name: 'asuminen',
    label: 'ASUMISEN LAADUKKUUS',
    svg: <FaPeopleGroup />
  },
  {
    name: 'vuoresaukio_ja_julkiset_kaupunkitilat',
    label: 'VUORESAUKIO JA JULKISET KAUPUNKITILAT',
    svg: <FaBorderNone />
  },
  {
    name: 'kaupunkikuva_ja_kaupunkirakenne',
    label: 'KAUPUNKIKUVA JA KAUPUNKIRAKENNE',
    svg: <GiModernCity />
  },
  {
    name: 'ilmasto_ja_kestävyys',
    label: 'ILMASTO JA KESTÄVYYS',
    svg: <HiOutlineLightBulb />
  },
  {
    name: 'toteuttamiskelpoisuus',
    label: 'TOTEUTTAMISKELPOISUUS',
    svg: <TbProgressCheck />
  },
  {
    name: 'arkkitehtoninen_laatu',
    label: 'ARKKITEHTONINEN LAATU',
    svg: <GiModernCity />
  }
]

export const rating_fields_for_specialist = [
  {
    name: 'expert_weighted_average_score',
    label: `Total`,
    svg: <MdInsertChart />
  },
  {
    name: 'tiimi_1_toimintojen_sijoittuminen_ja_yhteydet',
    label: 'tiimi 1 Toimintojen sijoittuminen ja yhteydet',
    svg: <MdRoute />
  },
  {
    name: 'tiimi_1_osastojen_toiminta_hoitohenkilökunnan_näkökulmasta',
    label: 'tiimi 1 Osastojen toiminta hoitohenkilökunnan näkökulmasta',
    svg: <TbNurse />
  },
  {
    name: 'tiimi_1_osastomoduuli_ja_potilashuone',
    label: 'tiimi 1 Osastomoduuli ja potilashuone',
    svg: <MdOutlineBedroomChild />
  },
  {
    name: 'tiimi_1_kuntoutumisen_mahdollisuudet',
    label: 'tiimi 1 Kuntoutumisen mahdollisuudet',
    svg: <GiHealthIncrease />
  },
  {
    name: 'tiimi_2_hälytys-,_henkilö-_ja_huoltoliikenteen_sujuvuus',
    label: 'tiimi 2 Hälytys-, henkilö- ja huoltoliikenteen sujuvuus',
    svg: <BiTrafficCone />
  },
  {
    name: 'tiimi_2_ajoneuvo-_ja_polkupyöräpysäköinti',
    label: 'tiimi 2 Ajoneuvo- ja polkupyöräpysäköinti',
    svg: <GoWorkflow />
  },
  {
    name: 'tiimi_2_sisälogistiikan_henkilö-_ja_materiaalivirrat',
    label: 'tiimi 2 Sisälogistiikan henkilö- ja materiaalivirrat',
    svg: <GoWorkflow />
  },
  {
    name: 'tiimi_2_rakennuksen_ylläpito',
    label: 'tiimi 2 Rakennuksen ylläpito',
    svg: <BsBuildingGear />
  },
  {
    name: 'tiimi_3_toteutettavuus_ja_pitkäaikaiskestävyys',
    label: 'tiimi 3 Toteutettavuus ja pitkäaikaiskestävyys',
    svg: <TbTimeDuration30 />
  },
  {
    name: 'tiimi_3_runko-_ja_taloteknisten_järjestelmien_johdonmukaisuus',
    label: 'tiimi 3 Runko- ja taloteknisten järjestelmien johdonmukaisuus',
    svg: <TbKeyframes />
  },
  {
    name: 'tiimi_3_energiatehokkuus',
    label: 'tiimi 3 Energiatehokkuus',
    svg: <MdOutlineEnergySavingsLeaf />
  }
]
